import { useEffect, useState } from 'react';
import { flowsApi } from 'apis/flows';
import { usePaginatedEndpoint } from 'utils/apis/pagination/usePaginatedEndpoint';
/**
 * A hook that handles fetching and paginating schedule flows on the business
 * hours schedule flows overview page.
 */
export function useScheduleFlows(scheduleId, limit = 50) {
    const [currentPageFlows, setCurrentPageFlows] = useState([]);
    const { asyncStatus, hasNextPage, hasPreviousPage, items, nextPage, previousPage, refetchItems, } = usePaginatedEndpoint({
        endpoint: flowsApi.endpoints.readFlowsSchedulesFlows,
        initialArg: { id: scheduleId, limit },
        itemsSelector: ({ data: { flows } }) => flows,
    });
    // Updates local state of current page schedule flows that is used for
    // populating the table.
    useEffect(() => {
        setCurrentPageFlows(items);
    }, [items]);
    return {
        asyncStatus,
        currentPageFlows,
        hasNextPage,
        hasPreviousPage,
        nextPage,
        previousPage,
        refetchItems,
    };
}
